// extracted by mini-css-extract-plugin
module.exports = {"root":"_23lXF","IndentedMenuButtonNSkin":"_17bbt","indentedMenuButtonNSkin":"_17bbt","linkElement":"_10pVr","extra":"_2W52v","wrapper":"_2m1hj","label":"_3Ap_h","bg":"_2px39"};